(function($){
    $().ready(function () {
        let button = document.getElementById('show-password');
        if (button) {
            button.addEventListener("click", showPassword);
        }
        function showPassword (event) {
            let input = document.getElementById('password');
            if (input.getAttribute('type') === "text") {
                input.setAttribute('type', 'password')
            } else {
                input.setAttribute('type', 'text')
            }
        }

        $('#form-lost-login').submit(function(e){
            e.preventDefault();

            let formData = $(this).serialize();

            $(document.body).css({'cursor' : 'wait'});

            fetch($(this).attr('action'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: formData,
            })
                .then(response => response.json())
                .then(response => {
                    $(document.body).css({'cursor' : 'default'});

                    if(response.data.error) {
                        let errorDiv = $('.errors')
                        errorDiv.toggle();
                        errorDiv.html("<span>Une erreur est survenu :</span>" + response.data.error)
                        return;
                    }

                    window.location.replace(response.data.redirect)
                });
        });
    });

})(jQuery);